import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
var DashboardService = /** @class */ (function () {
    function DashboardService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    DashboardService.prototype.getDashboardDetails = function (body) {
        var url = environment.apiBase + ("popup/stats?startDate=" + body.startDate + "&endDate=" + body.endDate + "&type=" + body.type);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    return DashboardService;
}());
export { DashboardService };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/dashboard.service.ts.pre-build-optimizer.js